// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"228":"42883640","371":"6e7001a5","705":"49a488d9","825":"7f389877","886":"26386a2d","978":"fad2c632"}[chunkId] + ".css";
};